import { useQuery } from 'react-query';
import { service } from '../redux/api/axios';

const useHook = (id: string) => {
  return useQuery(['file_by_id', id], async () => {
    if (!id) {
      return null;
    }
    const response = await service.get(`/library/${id}`);
    return response.data;
  });
};

export default useHook;
